import { ClipPath, Defs, G, Mask, Path, Rect, Svg } from "react-native-svg";

export const TrailsIcon = () => {
  return (
    <Svg
      width="100%"
      height="100%"
      viewBox="0 0 30 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <G clipPath="url(#clip0_101_3944)">
        <Path
          d="M29.1667 8.33333C29.0625 8.33333 28.9583 8.35417 28.8542 8.39583L20 11.6667L19.4635 11.4792C20.6771 9.66146 21.6667 7.77083 21.6667 6.40625C21.6667 2.86458 18.6823 0 15 0C11.3177 0 8.33333 2.86979 8.33333 6.40625C8.33333 7.02083 8.54167 7.75 8.875 8.52083L1.04688 11.25C0.416667 11.5 0 12.1146 0 12.7969V25.8333C0 26.3125 0.390625 26.6667 0.833333 26.6667C0.9375 26.6667 1.04167 26.6458 1.14583 26.6042L10 23.3333L18.9583 26.4948C19.6354 26.7188 20.3646 26.724 21.0417 26.5052L28.9531 23.75C29.5885 23.4948 30 22.8854 30 22.2031V9.16667C30 8.6875 29.6094 8.33333 29.1667 8.33333ZM9.16667 21.8646L1.66146 24.6354L1.59375 12.8177L9.16667 10.1875V21.8646ZM15 1.66667C17.7552 1.66667 20 3.79167 20 6.40625C20 7.8125 18.0156 11.0365 15 14.5729C11.9844 11.0365 10 7.8125 10 6.40625C10 3.79167 12.2448 1.66667 15 1.66667ZM19.1667 24.8021L10.8333 21.8594V11.9167C12.1042 13.7552 13.5469 15.4583 14.3594 16.3802C14.526 16.5729 14.7656 16.6667 15 16.6667C15.2344 16.6667 15.4687 16.5729 15.6406 16.3802C16.3073 15.625 17.3958 14.3438 18.4688 12.8958L19.1667 13.1406V24.8021ZM20.8333 24.8125V13.1354L28.3385 10.3646L28.4062 22.1823L20.8333 24.8125ZM16.25 6.66667C16.25 5.97396 15.6875 5.41667 15 5.41667C14.3125 5.41667 13.75 5.97396 13.75 6.66667C13.75 7.35417 14.3125 7.91667 15 7.91667C15.6875 7.91667 16.25 7.35938 16.25 6.66667Z"
          fill="#A8C492"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_101_3944">
          <Rect width="30" height="26.6667" fill="white" />
        </ClipPath>
      </Defs>
    </Svg>
  );
};

export const IconeSeRelaxer = () => {
  return (
    <Svg
      width="100%"
      height="100%"
      viewBox="0 0 33 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <G clipPath="url(#clip0_101_3951)">
        <Path
          d="M25.9143 17.2773L32.4658 19.308C32.7308 19.3883 32.9995 19.1933 32.9995 18.9196V18.0695C32.9995 17.8912 32.8814 17.7338 32.7082 17.681L26.4 15.7239V12.3464C26.4 11.215 26.1004 10.1034 25.5301 9.12133L21.071 1.43508C20.5585 0.549961 19.5974 0 18.562 0C17.7994 0 17.0533 0.305195 16.5 0.860234C15.9467 0.305195 15.2006 0 14.438 0C13.4026 0 12.4415 0.549961 11.929 1.43508L7.46934 9.12184C6.89957 10.1041 6.59992 11.2157 6.6 12.347V15.7244L0.291328 17.681C0.207003 17.7066 0.133224 17.7582 0.0807981 17.8281C0.0283726 17.898 5.70792e-05 17.9826 0 18.0695L0 18.9196C0 19.1928 0.268641 19.3883 0.533672 19.308L7.0852 17.2773C7.77717 17.0676 8.24949 16.4374 8.24949 15.7244V12.347C8.24949 11.4984 8.4743 10.6646 8.90175 9.92824L13.3624 2.23996C13.7197 1.62246 14.4885 1.47012 15.0511 1.78598C15.6441 2.12012 15.8503 2.86508 15.5121 3.44906L12.2023 9.15332C11.7749 9.88995 11.5501 10.7236 11.55 11.572V15.8443C11.55 16.0687 11.7346 16.2505 11.9625 16.2505H12.7875C13.0154 16.2505 13.2 16.0687 13.2 15.8443V12.5943C13.2 11.9214 13.7543 11.3755 14.4375 11.3755C15.1207 11.3755 15.675 11.9214 15.675 12.5943V16.9655C15.675 18.7865 14.4442 20.3851 12.6643 20.8772L0.301125 24.3587C0.21454 24.3827 0.138273 24.4339 0.0839201 24.5045C0.0295671 24.5751 0.000100489 24.6612 0 24.7498L0 25.5938C0 25.8629 0.260906 26.0574 0.523875 25.9848L13.1098 22.4418C14.5747 22.037 15.7601 21.0895 16.5 19.8656C17.2399 21.0889 18.4253 22.037 19.8902 22.4418L32.4761 25.9848C32.7391 26.0574 33 25.8629 33 25.5938V24.7498C33 24.5675 32.8768 24.408 32.6989 24.3587L20.3357 20.8772C18.5553 20.3851 17.325 18.7865 17.325 16.9655V12.5943C17.325 11.9214 17.8793 11.3755 18.5625 11.3755C19.2457 11.3755 19.8 11.9214 19.8 12.5943V15.8443C19.8 16.0687 19.9846 16.2505 20.2125 16.2505H21.0375C21.2654 16.2505 21.45 16.0687 21.45 15.8443V11.572C21.45 10.7235 21.2252 9.88965 20.7977 9.15332L17.4879 3.44906C17.1497 2.86508 17.3559 2.12012 17.9489 1.78598C18.5145 1.46809 19.2828 1.62652 19.6376 2.23996L24.0982 9.92824C24.5257 10.6648 24.7505 11.4986 24.7505 12.347V15.7244C24.75 16.4374 25.2223 17.0671 25.9143 17.2773ZM19.2983 9.84395C18.9709 9.75863 18.6208 9.72918 18.2588 9.76574C17.5545 9.83684 16.9507 10.1832 16.5 10.6773C16.0499 10.1832 15.4455 9.83684 14.7412 9.76574C14.3798 9.72918 14.0296 9.75863 13.7017 9.84395L16.5 5.02176L19.2983 9.84395Z"
          fill="#A8C492"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_101_3951">
          <Rect width="33" height="26" fill="white" />
        </ClipPath>
      </Defs>
    </Svg>
  );
};

export const IconeSmile = () => {
  return (
    <Svg
      width="100%"
      height="100%"
      viewBox="0 0 27 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M13.5 0.4375C6.04234 0.4375 0 6.50781 0 14C0 21.4922 6.04234 27.5625 13.5 27.5625C20.9577 27.5625 27 21.4922 27 14C27 6.50781 20.9577 0.4375 13.5 0.4375ZM13.5 25.8125C7.01673 25.8125 1.74194 20.5133 1.74194 14C1.74194 7.48672 7.01673 2.1875 13.5 2.1875C19.9833 2.1875 25.2581 7.48672 25.2581 14C25.2581 20.5133 19.9833 25.8125 13.5 25.8125ZM18.4101 17.8172C17.1907 19.2828 15.3998 20.125 13.5 20.125C11.6002 20.125 9.80927 19.2828 8.58992 17.8172C8.27964 17.4453 7.72984 17.3961 7.36512 17.7078C6.99496 18.0195 6.94597 18.5664 7.25625 18.9383C8.80222 20.8031 11.0831 21.875 13.5 21.875C15.9169 21.875 18.1978 20.8031 19.7492 18.9328C20.0595 18.5609 20.0105 18.0086 19.6403 17.7023C19.2702 17.3961 18.7204 17.4453 18.4101 17.8172ZM9.14516 13.125C10.1087 13.125 10.8871 12.343 10.8871 11.375C10.8871 10.407 10.1087 9.625 9.14516 9.625C8.18165 9.625 7.40323 10.407 7.40323 11.375C7.40323 12.343 8.18165 13.125 9.14516 13.125ZM17.8548 13.125C18.8183 13.125 19.5968 12.343 19.5968 11.375C19.5968 10.407 18.8183 9.625 17.8548 9.625C16.8913 9.625 16.1129 10.407 16.1129 11.375C16.1129 12.343 16.8913 13.125 17.8548 13.125Z"
        fill="#A8C492"
      />
    </Svg>
  );
};

export const MaskGroup = () => {
  return (
    <Svg
      width="100%"
      height="100%"
      viewBox="0 0 160 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Mask
        id="mask0_101_3940"
        style="MaskTypeAlpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="160"
        height="56"
      >
        <Rect width="160" height="55.3173" rx="10" fill="#E1E8DC" />
      </Mask>
      <G mask="url(#mask0_101_3940)">
        <Rect
          opacity="0.25"
          y="-105.033"
          width="160"
          height="160"
          rx="80"
          fill="#A8C492"
        />
      </G>
    </Svg>
  );
};

export const CloseIcon = ({ color }) => {
  return (
    <Svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M18.3007 5.70973C17.9107 5.31973 17.2807 5.31973 16.8907 5.70973L12.0007 10.5897L7.1107 5.69973C6.7207 5.30973 6.0907 5.30973 5.7007 5.69973C5.3107 6.08973 5.3107 6.71973 5.7007 7.10973L10.5907 11.9997L5.7007 16.8897C5.3107 17.2797 5.3107 17.9097 5.7007 18.2997C6.0907 18.6897 6.7207 18.6897 7.1107 18.2997L12.0007 13.4097L16.8907 18.2997C17.2807 18.6897 17.9107 18.6897 18.3007 18.2997C18.6907 17.9097 18.6907 17.2797 18.3007 16.8897L13.4107 11.9997L18.3007 7.10973C18.6807 6.72973 18.6807 6.08973 18.3007 5.70973Z"
        fill={color ? color : "#1B4965"}
      />
    </Svg>
  );
};
